<template>
  <div class="operation-bar" :class="{ 'app-entry-disabled': isCps, 'show-app-bar': showAppBar }" >
    <!-- <p class="btn-tips" v-show="buyNowText.btnTips"> -->
    <p class="btn-tips" v-show="tips">
      <!-- <van-icon name="info-o" />&nbsp;{{ buyNowText.btnTips }} -->
      <van-icon name="info-o" />&nbsp;{{ tips }}
    </p>

    <span class="icon">
      <van-icon name="chat-o" @click="handleTokfClick" />
      <span>Chat</span>
    </span>
    <span v-if="!isCps" class="icon" @click="handleToStoreClick">
      <van-icon name="shop-o" />
      <span>Store</span>
    </span>
    <span v-if="!isCps" class="icon">
      <van-badge :show-zero="false" :max="99" :content="shipingCartTotal">
        <van-icon name="cart-o" @click="handleToShoppingCartClick" />
      </van-badge>
      <span>Cart</span>
    </span>
    
    <ClientOnly v-if="isExtremeDiversion">
      <div class="opt-bar">
        <a
          :href="purchaseDeepLinkUrl"
          class="opt-btn red-btn app-only-btn"
          @click="handleOpenAppClick"
        >
          <span class="app-only-text">Purchase Only In Kilimall APP</span>
          <van-icon name="arrow" class="app-only-arrow" />
        </a>
      </div>
    </ClientOnly>
    <div v-else class="opt-bar">
      <div
        v-if="isSupportMergeCommit && !isCps"
        :class="isSale ? 'opt-btn add-car-btn' : 'opt-btn disabled-opt-btn'"
        @click="handleAddCartClick"
      >Add To Cart</div>
      <div
        :class="isSale ? 'opt-btn red-btn' : 'opt-btn disabled-opt-btn'"
        @click="handleBuyNowClick"
      >Order Now</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { webClickFn } from '@/plugins/bi-sa.client'
import { useWapListingDetailVersionState } from '@/utils/wap-listing-detail-version'

const { $SENSORS_EVENT } = useNuxtApp()
const props = defineProps<{
  isCps?: boolean
  isSupportMergeCommit: boolean,
  activityProgress: boolean,
  isSale?: boolean
  listingId: number
  storeId?: number | string
  tips?: string
  showAppBar?: boolean
  appLinkId: number
  appLinkSource: 0 | 1
}>()

const emits = defineEmits<{
  (event: 'order:now', type: ProductV2.IOptionType): void
  (event: 'to:chat'): void
}>()

const wapListingDetailVersion = useWapListingDetailVersionState()
const isExtremeDiversion = computed(() => !props.isCps && wapListingDetailVersion.value === '2')
const { getDeepLinkUrl, handleOpenAppClick } = useProductDeepLink(
  () => props.appLinkId,
  () => props.appLinkSource
)
const purchaseDeepLinkUrl = getDeepLinkUrl('purchase')

const shipingCartTotal = useShopingCartTotal()

const router = useRouter()
const handleAddCartClick = () => {
  if(!props.isSale) {
    return
  }
  webClickFn(1, 'Add To Cart', true)
  emits('order:now', 'add-to-cart')
}

const handleBuyNowClick = () => {
  if(!props.isSale) {
    return
  }
  webClickFn(2, 'Order Now', true)
  emits('order:now', 'order-now')
}

const handleToShoppingCartClick = () => {
  router.push('/shopping-cart')
}
const handleTokfClick = () => {
  emits('to:chat')
}
const handleToStoreClick = () => {
  props.storeId && router.push({
    path: `/store/${props.storeId}`,
    query: { first_page: 'productDetail' }
  })
}
</script>

<style lang="scss" scoped>
.btn-tips{
  position: absolute;
  top: -60px;
  left: 0;
  right: 0;
  padding: 0 30px;
  font-size: 24px;
  height: 60px;
  line-height: 60px;
  background-color: #f74711;
  color: #fff;
  i { font-size: 24px; }
}
.operation-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  height: 100px;
  @include center();
  padding: 0 20px;
  .icon{
    width: 75px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 22px;
    text-align: center;
    i{
      font-size: 48px;
    }
  }
  .opt-bar{
    @include center();
    flex: 1;
    height: 78px;
    line-height: 78px;
    overflow: hidden;
    border-radius: 80px;
    border: 1px solid var(--default_color);
  }
  .opt-btn{
    flex: 1;
    text-align: center;
    font-weight: 600;
    height: 100%;
  }
}
.show-app-bar{
  bottom: 122px;
}
:global(html[data-kili-app-entry="browser"] .operation-bar:not(.app-entry-disabled)) {
  bottom: 122px;
}
.disabled-opt-btn {
  color: #fff !important;
  line-height: 72px;
  border: 1px solid transparent !important;
  box-sizing: border-box;
  background: gray !important;
}

.add-car-btn{
  color: var(--default_color);
}
.red-btn{
  color: #fff;
  background-color: #e04545;
}
.app-only-btn{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-decoration: none;
  gap: 4px;
  .app-only-text{
    line-height: 1;
    font-size: 26px;
  }
  .app-only-arrow{
    font-size: 28px;
    line-height: 1;
  }
}
</style>
